{
  "column": {
    "name": "Name",
    "type": "Typ",
    "subscribedServices": "Abonnierte Dienste",
    "expirationDate": "Ablaufdatum",
    "expirationDateFormat": "YYYY/MM/DD [um] hh:mm A"
  },
  "addSingleCertificate": "Ein Zertifikat hinzufügen",
  "addCertificate": "Zertifikat hinzufügen",
  "updateCertificate": "Zertifikat aktualisieren",
  "certificate": {
    "typeTitle": "Art des Zertifikats",
    "deviceTrustchain": "Geräte-Trustchain",
    "pkiRootCa": "MS PKI Root CA",
    "ldapsRootCa": "LDAPS Root CA"
  },
  "caRestrictionInformation": "Das eingereichte Zertifikat muss eine .PEM-Datei sein und darf maximal 1 MB groß sein.",
  "dropCertificate": "Legen Sie das Zertifikat hier ab oder klicken Sie hier, um die Auswahl zu starten.",
  "noCertificate": "Es sind keine Zertifikate im Truststore registriert.",
  "validation": {
    "rootCa": "Zertifikat ist erforderlich und muss eine .PEM-Datei sein",
    "certType": "Zertifikatstyp ist erforderlich"
  }
}
